<template lang="pug">
    div(:class="'context-'+context")
        include SocialMedia.pug
</template>

<script>
import { mapState } from 'vuex';
import { Tweet, Moment, Timeline } from 'vue-tweet-embed'
import VueInstagram from 'vue-instagram'

export default {
  name: 'SocialMedia',
  components: {
    Tweet, Moment, Timeline,
    VueInstagram,
  },
  computed: mapState([
    "context",
  ]),
  data: function() {
    return {
      optionsTimeline: {
        tweetLimit: 1,
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@import "SocialMedia";

</style>



// WEBPACK FOOTER //
// src/components/social_media/SocialMedia.vue